// extracted by mini-css-extract-plugin
var _1 = "BucksOdometer__bao--OqGgw CoreGeneral__baoFont--dcsOj";
var _2 = "BucksOdometer__digitOuter--M8ry6";
var _3 = "BucksOdometer__main--Kewfu";
export { _1 as "bao", _2 as "digitOuter", _3 as "main" }
